/** Zentrale SEO-Helfer für strukturierte Daten (schema.org). */

export const SITE_URL = "https://www.moebix.de";

/**
 * Offer.priceValidUntil (schema.org) — von Google für Product-/Merchant-
 * Listings empfohlen; Fehlen löst Warnungen in der Search Console aus.
 * Liefert ein Datum ~60 Tage in der Zukunft als ISO-Datum (YYYY-MM-DD).
 */
export function priceValidUntil(from: Date = new Date()): string {
  const d = new Date(from.getFullYear(), from.getMonth(), from.getDate() + 60);
  return d.toISOString().slice(0, 10);
}
